import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {PurchaseService} from '../../../services/purchase.service';
import {finalize} from 'rxjs/operators';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {FormService} from '../../../services/form.service';
import {ValidateService} from "../../../modules/validate/validate.service";
import {ProductType} from '../../../utils/product';
import * as moment from 'moment';

@Component({
  selector: 'modal-bonus',
  templateUrl: './modal-bonus.component.html',
})
export class ModalBonusComponent implements OnInit {

  form: FormGroup;
  user: number;
  item: any = {};
  parentStore: any;
  subscriptionForm: any;
  consumableForm: any;
  nonConsumableForm: any;
  costForm: any;
  types: any = [{
    label: 'Subscription',
    key: 'Subscription'
  }, {
    label: 'Consumable',
    key: 'Consumable'
  }, {
    label: 'NonConsumable',
    key: 'NonConsumable'
  }];

  entities: any = [{
    label: 'Project',
    key: 'project'
  }, {
    label: 'Collection',
    key: 'storeCollection'
  }]

  @Output() purchased: EventEmitter<any> = new EventEmitter<any>();

  constructor(public modalRef: BsModalRef,
              private toastr: ToastrService,
              private userService: UserService,
              private formService: FormService,
              private validateService: ValidateService,
              private purchaseService: PurchaseService) { }

  ngOnInit(): void {

    this.initForm();
    this.get()
  }

  initForm() {
    this.form = new FormBuilder().group({
      // parentStore: [this.parentStore, Validators.required],
      productType: [this.types[0].key, Validators.required],
      comment: [],
      sandBox: [false]
    });

    this.initSubForm();
  }

  addPurchase(): void {
    if (this.validateService.validate(this.form)) {
      setTimeout(() => { this.form.disable() });
      let body = Object.assign(this.form.value, {user: this.user});
        if (body.period) {
          body.expiredAt = moment(body.period.end).endOf('day').toDate();
          body.startedAt = moment(body.period.start).startOf('day').toDate();
        }
        this.purchased.emit();
      this.purchaseService.create(body).pipe(
        finalize(() => {
          this.form.enable();
          this.modalRef.hide();
        })
      ).subscribe();
    } else {
      this.toastr.warning('Please, fill correct', 'Warning');
    }
  }

  get(): void {
    this.userService.get({
      id: this.user,
      relations: ['account', 'store']
    }).subscribe((res: any) => {
          this.item = res;
        },
        err => {
        }
      );
  }

  initSubForm() {
    this.subscriptionForm = {
      period: new FormControl(null, [Validators.required]),
      // startPeriod: new FormControl(null, [Validators.required]),
      // expiredAt: new FormControl(null, [Validators.required]),
    };
    this.consumableForm = {
      coinsValue: new FormControl(null, [Validators.required]),
    };
    this.nonConsumableForm = {
      entity: new FormControl(null, [Validators.required]),
      project: new FormControl(),
      storeCollection: new FormControl(),
    };

    this.initSubscription();
  }

  typeChange$: Subscription;
  initSubscription() {
    this.toggleByType(this.form.get('productType').value);

    this.typeChange$ = this.form.get('productType').valueChanges.subscribe((result) => {
      this.toggleByType(result);
    });
  }

  toggleByType(result: any) {
    this.formService.toggleControls(this.form, this.subscriptionForm, result === ProductType.Subscription);
    this.formService.toggleControls(this.form, this.consumableForm, result === ProductType.Consumable);
    this.formService.toggleControls(this.form, this.nonConsumableForm, result === ProductType.NonConsumable);
  }

}
